import { Component, OnInit} from '@angular/core';
import { AddEditPlayerComponent } from '../player/add-edit-player/add-edit-player.component';
import { Location } from '@angular/common';
import { AuthenticationService } from '../../services/authentication.service';
import { Player } from '../../models/Player';
import { PlayerService } from '../../services/player.service';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [AddEditPlayerComponent],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css'
})
export class ProfileComponent implements OnInit {
  constructor(private location:Location, private authenticationService:AuthenticationService, private playerService:PlayerService) {}

  player:Player|null = null;

  ngOnInit(): void {
    if(this.authenticationService.loginResult && this.authenticationService.loginResult.player)
    {
      this.getPlayer(this.authenticationService.loginResult.player.playerId);
    }
  }

  async getPlayer(playerId:number) {
    let players = await this.playerService.searchPlayers(playerId);
    this.player = players[0];
  }

  onProfileSaved() {
    this.browserBack();
  }

  onCancelProfileUpdateClicked() {
    this.browserBack();
  }

  browserBack() {
    this.location.back();
  }
}
